module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment-components/payment-method-list/payment-method-list.component.css
// module id = ./src/app/payment-components/payment-method-list/payment-method-list.component.css
// module chunks = main